const list = {
  path: 'kefu',
  component: resolve => require(['@/pages/admin/platform/kefu'], resolve)
}

export default list
